import React from 'react';
import { Modal, Button } from 'react-bootstrap';

// Shown only AFTER a like. This is the one place the real identity is revealed.
export default function RevealModal({ reveal, onClose }) {
  const show = Boolean(reveal);
  return (
    <Modal show={show} onHide={onClose} centered contentClassName="mp-reveal">
      <Modal.Body className="text-center">
        <div className="mp-reveal-tag">Added to your watchlist</div>
        {reveal?.poster_url && (
          <img
            className="mp-reveal-poster"
            src={reveal.poster_url}
            alt="Poster"
            onError={(e) => {
              e.currentTarget.style.display = 'none';
            }}
          />
        )}
        <h3 className="mp-reveal-title">{reveal?.title}</h3>
        {reveal?.year && <div className="mp-reveal-year">{reveal.year}</div>}
        <div className="mp-reveal-actions">
          {reveal?.plex_url && (
            <Button
              variant="warning"
              href={reveal.plex_url}
              target="_blank"
              rel="noreferrer"
            >
              Open in Plex
            </Button>
          )}
          <Button variant="outline-light" onClick={onClose}>
            Keep picking
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
